module.exports = __webpack_public_path__ + "img/pasture_brachiaria_middle.6b53f25d.jpg";